module.exports = __webpack_public_path__ + "static/2-e5c1ab7e0e95046a88811c13c7320eaf.jpg";